import {
  type IActivityOccurrenceStatus,
  type IUnfinishedActivityOccurrenceStatus,
  activityOccurrenceStatusSchema,
} from "@medoma/models/activities";

export const isUnfinishedOccurrence = <
  T extends { status: IActivityOccurrenceStatus },
>(
  occurrence: T,
): occurrence is T & {
  status: IUnfinishedActivityOccurrenceStatus;
} => occurrence.status !== activityOccurrenceStatusSchema.enum.finished;
